<template>
  <label :for="inputId" class="form-group row">
    <slot name="label">
      <span class="col-sm-2 col-form-label">{{ label }}</span>
    </slot>
    <div class="col-sm-10">
      <slot>
        <AppInput
          :model-value="modelValue"
          :id="inputId"
          @input="$emit('update:modelValue', $event.target.value)"
        />
      </slot>
    </div>
  </label>
</template>
  
<script>
import AppInput from "./AppInput.vue";
export default {
  inheritAttrs: false,
  emits: ["update:modelValue"],
  components: { AppInput },
  props: ["modelValue", "label", "inputId"],
};
</script>